import { updatePartner360Configuration } from 'legacy/lut/services/partner360/configuration/updatePartner360Configuration'
import { map621ToVerticalMarket } from 'legacy/lut/services/partner360/marketInfo/mappings/map621ToVerticalMarket'
import { mapVerticalMarketTo621 } from 'legacy/lut/services/partner360/marketInfo/mappings/mapVerticalMarketTo621'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { requestRecalculateCompleteness } from '../../completeness'
import { selectFinancialYear, selectPartner360Data } from '../../configuration'
import { REQUEST_PARTNER360_UPDATE_VERTICAL_MARKET_INFO } from '../constants'
import { IVerticalMarket } from '../models/IMarketInfo'

export const requestUpdateVerticalMarketInfo = createAsyncThunk<
  IVerticalMarket,
  Partial<IVerticalMarket>
>(REQUEST_PARTNER360_UPDATE_VERTICAL_MARKET_INFO, async (form, { getState, dispatch }) => {
  const state = getState()
  const configuration = selectPartner360Data(state)
  const fYear = selectFinancialYear(state)

  const dataToUpdate = mapVerticalMarketTo621(form)
  const updatedData = await updatePartner360Configuration({
    EntryId: configuration.entryId,
    PartnerId: configuration.partnerId,
    FYear: fYear,

    ...dataToUpdate,
  })

  await dispatch(
    requestRecalculateCompleteness({
      partnerId: configuration.partnerId,
      fYear,
    })
  )

  return map621ToVerticalMarket(updatedData)
})
